module.exports = __webpack_public_path__ + "static/dufner-pediatrica-f0fe8603a59ccbbe2ea1982361703799.jpg";